import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Portfolio from './Pages/Portfolio';
import CV from './Pages/CV';

function App() {
  return (
    <Routes>
      <Route path="/about" element={<About />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/cv" element={<CV />} />
      <Route path="/portfolio/media-and-society" element={<Portfolio />} />
      <Route path="/portfolio/health-and-science" element={<Portfolio />} />
      <Route path="/portfolio/art-and-design" element={<Portfolio />} />
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
